// PhonicsLt19.js
// 包装组件：Letter Teams L19
// 路由：/phonics/lt19
import React from 'react';
import PhonicsLt from './phonics/PhonicsLt';
import { letterDataLt19 } from './phonics/phonics_data_lt19';

function PhonicsLt19() {
  return <PhonicsLt letterData={letterDataLt19} />;
}

export default PhonicsLt19;
